import React, { useEffect } from "react";
import { useRouteMatch, useHistory } from "react-router-dom";
import parse from 'html-react-parser';
import { useDispatch, useSelector } from "react-redux";
import { setPageClass, setUpHeader } from "../../store/features/slice-ui";
import PageHead from "../../components/PageHead";
import PageContent from "../../components/PageContent";
import Cta from "../../components/Cards/Cta";
import { Word } from '../../components/Word';
import HorizontalScroller from '../../components/HorizontalScroller';
import FavDoctorCard from "../../components/Cards/DoctorCircular";
import Select from '../../components/Form/Select';


import { ReactComponent as DoctorIcon } from '../../assets/images/icons/doctor.svg';
import { ReactComponent as ScopeIcon } from '../../assets/images/icons/s_scope.svg';
import { ReactComponent as ClosestIcon } from '../../assets/images/icons/closest_location.svg';
import G from "../../app/globals";


const FindDoctorIndex = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const match = useRouteMatch();
  const breakPoint = useSelector((state) => state.ui.breakPoint);
  const isDesktop = !G.TABLET_BREAKPOINTS.includes(breakPoint);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const accountData = useSelector((state) => state.account.data);
  const doctorsListBasic = useSelector((state) => state.doctors.basic);
  useEffect(() => {
    dispatch(setPageClass("page-find-doctor"));
    dispatch(setUpHeader({
      show: true,
      logo: true,
      profile: true,
      search: true
    }));
  }, [dispatch]);

  const renderFavDoctorsCards = () => {
    return accountData && accountData.favourites && doctorsListBasic ? accountData.favourites.map(id => (
      doctorsListBasic[id] ? 
        <FavDoctorCard
            key={id}
            slug={doctorsListBasic[id].slug}
            image={doctorsListBasic[id].profileImage}
            title={parse(doctorsListBasic[id].salutation+" "+doctorsListBasic[id].name)}
            link={match.url === '/discuss-patient' ? ({pathname: `/doctor/${doctorsListBasic[id].slug}`, state: { prevPath: '/discuss-patient' }}) : `/doctor/${doctorsListBasic[id].slug}`}
        /> : null
    )) : null;
  };

  const handleDoctorSelectChange = (payload) => {
    if(match.url === '/discuss-patient'){
      history.push({pathname: `/doctor/${payload.value}`, state: { prevPath: '/discuss-patient' }});
    }
    else{
      history.push(`/doctor/${payload.value}`);
    }
  }
  
  
  return (
    <>
      <PageHead 
        className="page-find-doctor--page-head"
        title={match.url === '/discuss-patient' ? 'Discuss a Patient' : 'Find a Doctor'}
        bg="blue"
      />
      <PageContent className="page-find-doctor--page-content">
        <div className="page-find-doctor--ops">
          {accountData && accountData.favourites.length > 0 ? 
            <div className="page-find-doctor--favourites">
              <h2><Word value="Your favourites" /></h2>
              <HorizontalScroller scrollOffset={180}>
                {renderFavDoctorsCards()}
              </HorizontalScroller>
            </div>
          : null}
          <div className="page-find-doctor--quick-search">
          {doctorsListBasic && Object.values(doctorsListBasic).length > 0 ? 
             <>
                <h2><Word value="Quick search" /></h2>
                <Select 
                  name={'doctor_name'}
                  id={'doctor_name'}
                  options={Object.values(doctorsListBasic).map(item => ({ 'value': item['slug'], 'label': parse(item['name']) }))}
                  onChange={handleDoctorSelectChange}
                />
              </>
            : null}
          </div>
        </div>
        <div className="page-find-doctor--ctas">
          <Cta 
            title={<Word value="Search" />}
            subtitle="Find a Doctor by name, location or specialty"
            icon="chevron_right"
            iconBg="blue"
            svg={<ScopeIcon />}
            svgBg="yellow"
            isCentered
            isBordered
            link={isDesktop ? `${match.url}/search` : `${match.url}/filter`}
          />
          {isAuthenticated ? 
            <Cta 
              title={<Word value="Recently viewed" />}
              subtitle="Show recently viewed Doctors"
              icon="chevron_right"
              iconBg="blue"
              svg={<DoctorIcon />}
              svgBg="green"
              isCentered
              isBordered
              link={`${match.url}/recently-viewed`}
            />
          : null}
          {isAuthenticated ? 
            <Cta 
              title={<Word value="Closest to you" />}
              subtitle={accountData ? `Your closest specialists ${accountData.postcode ? 'to postcode '+accountData.postcode : ''}` : null}
              icon="chevron_right"
              iconBg="blue"
              svg={<ClosestIcon />}
              svgBg="blue"
              isCentered
              isBordered
              link={`${match.url}/closest`}
            />
          : null}
        </div>
      </PageContent>
    </>
  );
};

export default FindDoctorIndex;
